import { render, staticRenderFns } from "./reallocationpickup.vue?vue&type=template&id=716b45d6"
import script from "./reallocationpickup.vue?vue&type=script&lang=js"
export * from "./reallocationpickup.vue?vue&type=script&lang=js"
import style0 from "./reallocationpickup.vue?vue&type=style&index=0&id=716b45d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports